module.exports = __webpack_public_path__ + "img/activation-progress-1.5c56be80.png";